import { Link } from "react-router-dom";
import { Badge } from "../../ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import type { UploadSummary } from "../../../types/domain";

export function DevicesView({ summary, uploadId }: { summary: UploadSummary; uploadId: string }) {
  const groups = [
    ["Zones", summary.zonesSeen, "Zone", "ZONES"],
    ["Programs", summary.programsSeen, "Program", "PROGRAMS"],
    ["Points of Connection", summary.pointsOfConnectionSeen, "POC", "FLOW"],
    ["Master Valves", summary.masterValvesSeen, "Master Valve", "FLOW"],
    ["Moisture Sensors", summary.moistureSensorsSeen, "Sensor", "MOISTURE"],
    ["Two-Wire events", summary.mostActiveCategories.find((item) => item.category === "TWO_WIRE") ? ["Two-Wire"] : [], "", "TWO_WIRE"],
    ["BaseManager events", summary.mostActiveCategories.find((item) => item.category === "BASEMANAGER") ? ["BaseManager"] : [], "", "BASEMANAGER"],
  ] as const;

  return (
    <div className="grid gap-4 md:grid-cols-2">
      {groups.map(([title, values, prefix, filter]) => (
        <Card key={title}>
          <CardHeader>
            <CardTitle>{title}</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-wrap gap-2">
            {values.length ? (
              values.map((value) => (
                <Link
                  key={value}
                  to={`/app/uploads/${uploadId}?tab=timeline&filter=${filter}&q=${encodeURIComponent(value)}`}
                >
                  <Badge className="bg-white text-navy-900 ring-slate-300 hover:bg-slate-50">
                    {prefix ? `${prefix} ${value}` : value}
                  </Badge>
                </Link>
              ))
            ) : (
              <p className="text-sm text-slate-600">No detected entries.</p>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
